import { render } from "./TeamTeamTile-v2.vue?vue&type=template&id=651ea170&scoped=true"
import script from "./TeamTeamTile-v2.vue?vue&type=script&lang=js"
export * from "./TeamTeamTile-v2.vue?vue&type=script&lang=js"

import "./TeamTeamTile-v2.vue?vue&type=style&index=0&id=651ea170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651ea170"]])

export default __exports__